<template>
	<div class="media-details__templates">
		<div class="media-details__settings">
			<div class="typo-item fs--15 lh--18 color--gray-base mb--20">{{ t('popup.media.label.container') }}</div>
			<field-checkbox
				:name="t('popup.media.label.small')"
				v-model:list="containers"
				:value="'popup_panel_small'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.wide')"
				v-model:list="containers"
				:value="'popup_panel_wide'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.detached')"
				v-model:list="containers"
				:value="'popup_detached'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.icon')"
				v-model:list="containers"
				:value="'map_icon'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.bg')"
				v-model:list="containers"
				:value="'background_image'"
			></field-checkbox>
		</div>
		<div class="media-details__settings">
			<div class="typo-item fs--15 lh--18 color--gray-base mb--20">{{ t('popup.media.label.desc') }}</div>
			<field-checkbox
				:name="t('popup.media.label.photo')"
				v-model:list="types"
				:value="'photo'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.portrait')"
				v-model:list="types"
				:value="'portrait'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.graphic')"
				v-model:list="types"
				:value="'infographics'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.drawing')"
				v-model:list="types"
				:value="'drawing'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.illustration')"
				v-model:list="types"
				:value="'illustration'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.animation')"
				v-model:list="types"
				:value="'animation'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="'Lottie'"
				v-model:list="types"
				:value="'lottie'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.film')"
				v-model:list="types"
				:value="'film'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.voice')"
				v-model:list="types"
				:value="'voice'"
				class="mb--10"
			></field-checkbox>
			<field-checkbox
				:name="t('popup.media.label.music')"
				v-model:list="types"
				:value="'music'"
				class="mb--10"
			></field-checkbox>
		</div>
	</div>
</template>

<script>
import FieldCheckbox from '@/components/fields/FieldCheckbox';
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';

export default {
	components: {
		FieldCheckbox
	},
	props: {
		targetContainers: {
			type: Array,
			default:() => []
		},
		contentTypes: {
			type: Array,
			default:() => []
		}
	},
	emits: ["update:target-containers", "update:content-types"],
	setup(props, {emit}) {
		const {t} = useI18n();
		
		const containers = computed({
			get(){return props.targetContainers},
			set(value){
				emit("update:target-containers", value);
			}
		})
		const types = computed({
			get(){return props.contentTypes},
			set(value){
				emit("update:content-types", value);
			}
		})
		
		return {
			t,
			containers,
			types,
		}
	}
}
</script>

<style lang="scss">

</style>
